"use strict";

/**
 * External Dependencies
 */

import "./sliders";
import "./misc";
import "./animations";
import "./form";
import "./newsletter";
import "./modal";

var ready = (callback) => {
  if (document.readyState != "loading") callback();
  else document.addEventListener("DOMContentLoaded", callback);
};

ready(() => {
  if (window.calendar) {
    window.calendar.setOption("firstDay", 1); // This sets Sunday as the first day of the week
  } else {
    console.error("FullCalendar object not found.");
  }
});
